<!--
全选控制。
需要与 <checkbox /> 搭配使用

用例：
<check-all value="['normal', 'group']" v-model="selectedUserTypes"></check-all>

<checkbox value="normal" v-model="selectedUserTypes"></checkbox>
<checkbox value="group" v-model="selectedUserTypes"></checkbox>

//-->
<template>
  <bool-checkbox v-model="isEquals" class="check-all-component" :disabled="disabled" :text="text" @changed="_changedSelection">
    <slot></slot>
  </bool-checkbox>
</template>

<script>
import ArrayMixin from '../../mixins/array_mixin'
export default {
  mixins: [ArrayMixin],
  model: {
    prop: 'selection',
    event: 'changed'
  },
  props: {
    /**
     * 全部的选项
     */
    value: {
      type: Array,
      default: () => []
    },
    /**
     * 当前选中的值
     */
    selection: {
      type: Array,
      default: () => []
    },
    /**
     * check all 的文本
     * 可以通过 text 属性，也可以 通过 slot
     */
    text: {
      type: String,
      default: ''
    },
    /**
     * 是否禁用
     */
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isEquals: false
    }
  },
  watch: {
    // 当前选中的值变化了
    selection: {
      handler() {
        this.isEquals = !this.isEmptyObject(this.value) && this.isArrayValueEquals(this.value, this.selection)
      },
      immediate: true
    },
    // 权限的选项列表变化了
    value(newValue, oldValue) {
      const isValueChanged = !this.isArrayValueEquals(newValue, oldValue)

      // 选项变化后，则重置选中的值 (其他 checkbox 会更新 value 的值，有可能导致 value 刷新)
      if (isValueChanged && !this.isEmptyObject(this.selection)) {
        this.$emit('changed', [])
      }

      this.isEquals = !this.isEmptyObject(this.value) && this.isArrayValueEquals(this.value, this.selection)
    }
  },
  methods: {
    _triggerChangedEvent(isSelectedAll) {
      if (isSelectedAll) {
        this.$emit('changed', this.value)
      } else {
        this.$emit('changed', [])
      }
    },
    _triggerClickEvent() {
      this.$emit('click')
    },
    _changedSelection() {
      if (this.disabled) return
      this._triggerChangedEvent(this.isEquals)
      this._triggerClickEvent()
    }
  }
}
</script>
